import React from "react";
import styles from "./CoverPage.module.css";
import Bg from "/assets/PdfNew/P1bg.png";
import Cloud from "/assets/PdfNew/Cloud.png";
import Ladder from "/assets/PdfNew/Lader.png";
import TextCurve from "/assets/PdfNew/designYourOwnPath.png";
import Logo from "/assets/images/logo.png";

const CoverPage = ({ studentData = {}, school_board_name = "" }) => {
  console.log("studentData", studentData);
  console.log("school_board_name", school_board_name);
  return (
    <div className={styles.poster}>
      {/* Background */}
      <img src={Bg} alt="background" className={styles.bg} />

      {/* Curved text */}
      <img src={TextCurve} alt="Define your career path" className={styles.curveText} />

      {/* Cloud */}
      <img src={Cloud} alt="cloud" className={styles.cloud} />

      {/* Ladder + Person */}
      <img src={Ladder} alt="ladder" className={styles.ladder} />

      {/* Student Info */}
      <div className={styles.info}  >
        <p><strong>Student Name :</strong> {studentData?.student_name || ""} </p>
        <p><strong>Board :</strong> {school_board_name || ""}</p>
        <p><strong>Class :</strong> {studentData?.grade || ""}</p>
        <p>
          <strong>Date :</strong>{" "}
          {studentData?.generated_at
            ? new Date(studentData.generated_at).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
            : ""}
        </p>      </div>

      {/* Logo */}
      <img src={Logo} alt="logo" className={styles.logo} />
    </div>
  );
};

export default CoverPage;
